/**
 * An error that can be displayed as is to the user
 */
export class AppExternalError extends Error {
  constructor(message = "Une erreur inconnue s'est produite") {
    super(message);
  }
}
